/* ModalChangePassword.js */
/* @author: anghello */

import React, { useCallback, useState } from 'react';
import { Col, Modal, ModalBody, ModalHeader, Row, ModalFooter, FormGroup, Label, Button } from 'reactstrap';
import Strings from '../../../translations/Translations';
import { useAuth } from '../../../Context/Auth/AuthContext';
import { useForm } from 'react-hook-form';
import WAM from '../../../services/WAM';
import { toast } from 'react-toastify';

export default function ModalChangePassword({ isOpen, setIsOpen }) {
  const toggle = useCallback(() => setIsOpen(value => !value), [setIsOpen]);

  const { authenticated } = useAuth();
  const [loading, setLoading] = useState(false);
  const { register, formState: { errors }, handleSubmit, getValues, setValue } = useForm();

  const onSubmit = useCallback(async ({ current_password, new_password }) => {
    if (current_password && new_password) {
      setLoading(true);
      try {
        const response = await WAM.changeUserPassword({ un: authenticated.un, al: authenticated.al, oldPwd: current_password, newPwd: new_password });
        if (response && response.result === 'success') {
          toast.success(Strings('password_changed'));
          setValue('current_password', '');
          setValue('new_password', '');
          setValue('confirm_new_password', '');
        } else {
          const message = (response && response.error) ? response.error : Strings('error_on_update_password');
          toast.error(message);
        }
      } catch (err) {
        console.error(err);
        toast.error(`${Strings('error_on_update_password')} [REQ]`);
      }
      setLoading(false);
    }
  }, [setLoading, authenticated, setValue]);


  return (
    <Modal isOpen={isOpen} toggle={toggle} size='md'>
      <ModalHeader toggle={toggle}>
        {Strings('change_password')}
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col sm={12} className='mb-1'>
            <FormGroup>
              <Label className='pb-label-1'>{Strings('current_password')}</Label>
              <input
                type='password'
                className='form-control shadow pb-input-1'
                name='current_password'
                {...register('current_password', { required: true })}
              />
              {errors && errors.current_password && errors.current_password.type === 'required' && (
                <p role='alert' className='text-danger txt-small-1'>{Strings('password_is_required')}</p>
              )}
            </FormGroup>
          </Col>
          <Col sm={12} className='mb-1'>
            <FormGroup>
              <Label className='pb-label-1'>{Strings('new_password')}</Label>
              <input
                type='password'
                className='form-control shadow pb-input-1'
                name='new_password'
                {...register('new_password', { required: true })}
              />
              {errors && errors.new_password && errors.new_password.type === 'required' && (
                <p role='alert' className='text-danger txt-small-1'>{Strings('new_password_is_required')}</p>
              )}
            </FormGroup>
          </Col>
          <Col sm={12} className='mb-1'>
            <FormGroup>
              <Label className='pb-label-1'>{Strings('confirm_new_password')}</Label>
              <input
                type='password'
                className='form-control shadow pb-input-1'
                name='confirm_new_password'
                {...register('confirm_new_password', {
                  required: true,
                  validate: (value) => {
                    const new_password = getValues('new_password');
                    return new_password === value;
                  }
                })}
              />
              {errors && errors.confirm_new_password && errors.confirm_new_password.type === 'required' && (
                <p role='alert' className='text-danger txt-small-1'>{Strings('confirm_password_is_required')}</p>
              )}
              {errors && errors.confirm_new_password && errors.confirm_new_password.type === 'validate' && (
                <p role='alert' className='text-danger txt-small-1'>{Strings('passwords_must_match')}</p>
              )}
            </FormGroup>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter className='d-flex justify-content-between'>
        <Button color='secondary' onClick={toggle}>
          {Strings('cancel')}
        </Button>
        <Button
          color='primary'
          onClick={handleSubmit(onSubmit)}
          // loading={loading}
          disabled={loading}
        >
          {Strings('save')}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
